var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card card-event col-md-3",
      attrs: { id: "event-card-" + _vm.event.id },
    },
    [
      _c("div", { staticClass: "inner-wrapper" }, [
        _c("img", {
          staticClass: "img-responsive card-img-top",
          attrs: {
            src:
              "https://world-architects.com" +
              _vm.event.agenda_image.image_versions.w780,
            alt: "",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.showModal.apply(null, arguments)
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("h4", { staticClass: "card-title no-border" }, [
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.event.tour) + "\n\t\t\t"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-text" }, [
            _vm.event.guide
              ? _c("span", [_vm._v(_vm._s(_vm.event.guide)), _c("br")])
              : _vm._e(),
            _vm._v(" "),
            _vm.event.theme
              ? _c("div", { staticClass: "event-theme" }, [
                  _vm._v(_vm._s(_vm.event.theme)),
                  _c("br"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "event-more" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showModal.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "wa-arrow wa-arrow-right wa-arrow-small",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("event_registration.more_info")) +
                      "\n\t\t\t\t"
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "event-datetime" }, [
            _c("strong", [_vm._v(_vm._s(_vm.event.time_span))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "event-button",
            staticStyle: { "margin-top": "10px" },
          },
          [
            _vm.event.allow_registrations
              ? _c(
                  "a",
                  {
                    class: {
                      btn: true,
                      "btn-add-attendee": true,
                      "btn-default": !_vm.event.selected,
                      "btn-selected": _vm.event.selected,
                    },
                    attrs: {
                      href: "#",
                      id: "event-card-button-" + _vm.event.id,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.select.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$t("event_registration.attend")) +
                        "\n\t\t\t"
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.event.allow_registrations
              ? _c("div", { staticClass: "btn btn-default btn-add-attendee" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("event_registration.fully_booked")) +
                      "\n\t\t\t"
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("event-description-modal", { attrs: { event: _vm.event } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }